/**
 * Agent tools API — **mock local** (sin HTTP real).
 *
 * TODO(backend): Sustituir por `api` de `./apiClient.js` y rutas reales.
 */

const delay = (ms, value) =>
  new Promise((resolve) => {
    setTimeout(() => resolve(value), ms);
  });

export const getToolsList = async () =>
  delay(500, {
    data: {
      data: [
        {
          tool_id: 'send-email',
          name: 'Send email',
          description:
            'Send emails to communicate information or interact with other people.',
          type: 'action',
          category: 'conversations',
          required_parameters: [],
        },
        {
          tool_id: 'human-in-the-loop-alert',
          name: 'Human in the loop Alert',
          description:
            'Sends notifications or alerts to involve a human operator when manual intervention is required.',
          type: 'action',
          category: 'support',
          required_parameters: [],
        },
        {
          tool_id: 'follow-up',
          name: 'Follow Up',
          description:
            'Proactively follows up on previous actions to ensure compliance and gather feedback.',
          type: 'action',
          category: 'support',
          required_parameters: [],
        },
        {
          tool_id: 'web-search',
          name: 'Web Search',
          description:
            'Perform a web search given a specific query when the customer needs external information.',
          type: 'action',
          category: 'research',
          required_parameters: [],
        },
        {
          tool_id: 'schedule-appointment',
          name: 'Schedule appointment',
          description:
            'Coordinates appointments based on user availability and requirements.',
          type: 'action',
          category: 'scheduling',
          required_parameters: [],
        },
        {
          tool_id: 'repair-schedule',
          name: 'Repair Schedule',
          description:
            'Facilitates scheduling of repairs and assigning technicians by priority.',
          type: 'action',
          category: 'service',
          required_parameters: [],
        },
      ],
      msgCode: 'success',
    },
    status: 200,
  });

export const getAgentTools = async (_agentUuid) =>
  delay(500, {
    data: {
      data: [],
      msgCode: 'success',
    },
    status: 200,
  });

export const updateAgentTools = async (_agentUuid, body) =>
  delay(800, {
    data: {
      data: body.tools,
      msgCode: 'success',
      message: 'Tools updated successfully',
    },
    status: 200,
  });

export const removeToolFromAgent = async (_agentUuid, _toolId) =>
  delay(500, {
    data: {
      msgCode: 'success',
      message: 'Tool removed successfully',
    },
    status: 200,
  });
